import { defineStore } from 'pinia';
import { Auth, SetProp } from '../types/auth.type';

export const useAuthStore = defineStore('auth', {
  state: (): Auth => ({
    user: null,
    token: '',
    status: false,
  }),
  actions: {
    verifyPermission(payload: any) {
      this.user?.permission.includes(payload)
      return this.user?.permission.includes(payload)
    },
    logout() {
      this.user = null;
      this.token = '';
      this.status = false;
      // Solo eliminamos el user del localStorage (el token nunca estuvo ahí)
      localStorage.removeItem('user');
    },
    login(payload: any) {
      const { user, token } = payload;
      // El access token vive únicamente en memoria (Pinia).
      // El refresh token lo maneja el backend vía cookie HttpOnly.
      if (token) {
        this.token = token;
        // status lo setea refresh() cuando el guard carga el user completo con permisos
      }
      if (user) {
        this.user = user;
        // Guardamos el user en localStorage solo para hidratar la UI al recargar,
        // NUNCA para decisiones de autorización.
        localStorage.setItem('user', JSON.stringify(user));
      }
    },
    refresh(payload: any) {
      const { user, token } = payload;
      if (token) {
        this.token = token;
        this.status = true;
      }
      if (user) {
        this.user = user;
        localStorage.setItem('user', JSON.stringify(user));
      }
    },
    setProp(payload: SetProp) {
      return new Promise((resolve) => {
        if (payload.index) {
          if (payload.prop) {
            // @ts-ignore
            this[payload.key as keyof Auth][payload.index] = payload.value;
            resolve(
              // @ts-ignore
              this[payload.key as keyof Auth][payload.index][payload.prop],
            );
          } else {
            // @ts-ignore
            this[payload.key as keyof Auth][payload.index] = payload.value;
            // @ts-ignore
            resolve(this[payload.key as keyof Auth][payload.index]);
          }
        } else {
          // @ts-ignore
          this[payload.key as keyof Auth] = payload.value;
          resolve(this[payload.key as keyof Auth]);
        }
      });
    },
  },
});

export default useAuthStore;
